if (!window.Promise) window.Promise = require('promise-polyfill');
require('unfetch/polyfill');

Object.assign = require('object-assign');
require('intersection-observer');
// This is available locally because everyone who made one doesn't understand
// npm, apparently
require('./polyfills/classlist.js');



//////////////////
// WEBPACK FOOTER
// /Users/ryan/Projects/texastribune/primary-elections-2018/config/polyfills.js
// module id = NH0g
// module chunks = 1